export default "__VITE_ASSET__CVEoNSPZ__"